import * as localforage from "localforage";
import axios from "axios";
import textNoty from "../helpers/textNoty";
import { successHandling } from "../helpers/successHandling";
import { checkHasPermission } from "@/helpers/checkHasPermission";

export const getGroupListApi = async () => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/groups`,
    method: "GET",
    params: {
      company_id,
      group_category_name: "power"
    }
  });
  return res.data.groups;
};

export const getEventListApi = async (
  type,
  company_id,
  group_id,
  tag_id,
  start_date,
  end_date
) => {
  let res = await axios({
    url: `/api/v2/schedule/event`,
    method: "GET",
    params: {
      type,
      company_id: type === "company" ? company_id : undefined,
      group_id:
        type === "group"
          ? Array.isArray(group_id)
            ? group_id[0]
            : group_id
          : undefined,
      tag_id:
        type === "tag"
          ? Array.isArray(tag_id)
            ? tag_id[0]
            : tag_id
          : undefined,
      start_date,
      end_date
    }
  });
  return res.data;
};

export const getEvenApi = async id => {
  let res = await axios({
    url: `/api/v2/schedule/event/edit`,
    method: "GET",
    params: {
      id
    }
  });
  return res.data;
};

export const createEventApi = async (
  group_id,
  company_id,
  tag_id,
  selectType,
  task_type,
  schedule_type,
  cycle_type,
  dailyTimes,
  weeklyTimes,
  weeklySelect,
  end_type,
  times,
  start_datetime,
  end_datetime,
  t,
  successfulText
) => {
  let cycle_value;
  if (schedule_type === "daily") {
    cycle_value = cycle_type === "every" ? dailyTimes : "workdays";
  } else {
    cycle_value = weeklyTimes;
  }
  let cycle_days = [];
  Object.entries(weeklySelect).forEach(([key, value]) => {
    if (value === true) {
      cycle_days.push(key);
    }
  });
  try {
    let res = await axios({
      url: `/api/v2/schedule/event/create`,
      method: "POST",
      data: {
        type: selectType,
        company_id: selectType === "company" ? company_id : undefined,
        group_id: selectType === "group" ? group_id : undefined,
        tag_id: selectType === "tag" ? tag_id : undefined,
        task_type,
        schedule_type,
        cycle_type: schedule_type === "weekly" ? "weekly_days" : cycle_type,
        cycle_value,
        cycle_days: schedule_type === "weekly" ? cycle_days : undefined,
        end_type,
        run_times: end_type === "times" ? times : 1,
        start_datetime,
        end_datetime,
        os_type: task_type==="start"? 2: (task_type==="shutdown" && !checkHasPermission("schedule_task_android_power_off"))? 2: 0
      }
    });
    successHandling(t, successfulText);
    return res.data;
  } catch (error) {
    if (error.response.data.message.message === "failed") {
      textNoty(t("dialog.noDeviceOS"));
      return;
    }
  }
};

export const editEventApi = async (
  id,
  selectType,
  company_id,
  group_id,
  tag_id,
  task_type,
  schedule_type,
  cycle_type,
  dailyTimes,
  weeklyTimes,
  weeklySelect,
  end_type,
  times,
  start_datetime,
  end_datetime,
  t,
  successfulText,
  setDialogLoading
) => {
  let cycle_value;
  if (schedule_type === "daily") {
    cycle_value = cycle_type === "every" ? dailyTimes : "workdays";
  } else {
    cycle_value = weeklyTimes;
  }
  let cycle_days = [];
  Object.entries(weeklySelect).forEach(([key, value]) => {
    if (value === true) {
      cycle_days.push(key);
    }
  });
  try {
    let res = await axios({
      url: `/api/v2/schedule/event/update`,
      method: "PUT",
      data: {
        id,
        type: selectType,
        company_id: selectType === "company" ? company_id : undefined,
        group_id: selectType === "group" ? group_id : undefined,
        tag_id: selectType === "tag" ? tag_id : undefined,
        task_type,
        schedule_type,
        cycle_type: schedule_type === "weekly" ? "weekly_days" : cycle_type,
        cycle_value,
        cycle_days: schedule_type === "weekly" ? cycle_days : undefined,
        end_type,
        run_times: end_type === "times" ? times : 1,
        start_datetime,
        end_datetime,
        os_type: task_type==="start"? 2: (task_type==="shutdown" && !checkHasPermission("schedule_task_android_power_off"))? 2: 0
      }
    });
    successHandling(t, successfulText);
    return res.data;
  } catch (error) {
    setDialogLoading(false);
    if (error.response.data.message.message === "failed") {
      textNoty(t("dialog.noDeviceOS"));
      return;
    }
  }
};

export const deleteEventApi = async (id, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/schedule/event/delete`,
    method: "DELETE",
    data: {
      id
    }
  });
  successHandling(t, successfulText);
  return res.data;
};
